import { render, staticRenderFns } from "./ComunicadosList.vue?vue&type=template&id=6402e987&"
import script from "./ComunicadosList.vue?vue&type=script&lang=js&"
export * from "./ComunicadosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports